<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Reportes - Torneos: Equipos y Jugadores" />

    <Report />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Report from "@/components/Pages/Admin/Reports/tournament-teams-players.vue";

export default defineComponent({
  name: "ReportTournamentTeamsPlayersPage",
  components: {
    PageTitle,
    Report,
  },
});
</script>
